import { useQueryClient } from '@tanstack/react-query'
import { Moon, Sun } from 'lucide-react'
import { IconButton } from '@/components/ui'
import { track } from '@/lib/analytics'
import { saveUserPreference, useAuth } from '@/lib/auth'
import { t } from '@/lib/i18n'
import { setTheme, useTheme } from '@/lib/theme'

/**
 * Light or dark in one click, for visitors too (REDESIGN 11: light is the default; the avatar menu and Settings
 * also offer System). On the top bar and under the log in and sign up card. Members save the choice to their
 * account, like the avatar menu does.
 */
export function ThemeToggle({ size = 40 }: { size?: 36 | 40 }) {
  const { resolved } = useTheme()
  const { isLoggedIn } = useAuth()
  const qc = useQueryClient()
  const dark = resolved === 'dark'
  const onToggle = () => {
    const next = dark ? 'light' : 'dark'
    track('theme_changed', { theme: next, surface: 'toggle' })
    setTheme(next)
    if (isLoggedIn) void saveUserPreference(qc, { theme: next })
  }
  return (
    <IconButton
      aria-label={t('Dark mode')}
      aria-pressed={dark}
      icon={dark ? <Sun /> : <Moon />}
      size={size}
      onClick={onToggle}
      data-testid="theme-toggle"
    />
  )
}
